var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMauritania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40.0001C31.0455 40.0001 39.9998 31.0458 39.9998 20.0001C39.9998 8.95439 31.0455 8.39233e-05 19.9998 8.39233e-05C8.95412 8.39233e-05 -0.000183105 8.95439 -0.000183105 20.0001C-0.000183105 31.0458 8.95412 40.0001 19.9998 40.0001Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 23.1055C16.6697 23.1055 13.8876 20.7651 13.2051 17.6397C13.1002 18.1201 13.0433 18.6183 13.0433 19.1304C13.0433 22.9725 16.1578 26.0868 19.9998 26.0868C23.8418 26.0868 26.9563 22.9724 26.9563 19.1304C26.9563 18.6183 26.8994 18.1201 26.7946 17.6396C26.112 20.7651 23.33 23.1055 19.9998 23.1055Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 13.913L20.6473 15.9059H22.7429L21.0477 17.1376L21.6952 19.1305L19.9998 17.8987L18.3046 19.1305L18.9522 17.1376L17.257 15.9059H19.3523L19.9998 13.913Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritania);
export default __webpack_public_path__ + "static/media/mauritania.714934b2b47400a99f64c958944708b6.svg";
export { ForwardRef as ReactComponent };